var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details"},[_c('p',[_vm._v("City of Kyiv")]),_c('img',{attrs:{"src":require("@/assets/image.png"),"alt":"地図サンプル"}}),_c('button',{on:{"click":_vm.closepop}},[_vm._v("閉じる")])])}
var staticRenderFns = []

export { render, staticRenderFns }